/* istanbul ignore file */
import {createStylesParams, StyleParamType} from '@wix/tpa-settings';
import {baseStylesParams} from '../../styleParams/baseStylesParams';
import {IStylesParams, StylesParamKeys} from '../../styleParams/types';
import {CustomCssVarsFn} from '@wix/yoshi-flow-editor';
import {baseCustomCssVars} from '../../baseCustomCssVars';
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {updatedStyleParamsOverrides} from '../../styleParams/updatedStyleParamsOverrides';
import {GridType} from '../../types/galleryTypes';
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver';

export const customCssVars: CustomCssVarsFn = (params: CustomCssVarsFnParams) => ({
  ...baseCustomCssVars(params),
});
const stylesParams: IStylesParams = {
  ...baseStylesParams,
  ...updatedStyleParamsOverrides,
  gallery_gridType: {
    type: StyleParamType.Number,
    getDefaultValue: () => GridType.MANUAL,
  },
  gallery_showCategoryHeaderImage: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  gallery_showCategoryHeaderName: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  gallery_showCategoryHeaderDescription: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  gallery_showCategoriesBreadcrumbs: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  gallery_showCategories: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  gallery_showCategoriesProductsCounter: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  galleryMarginRow: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
};

export default createStylesParams<StylesParamKeys>(stylesParams);
